window.addEventListener('DOMContentLoaded', () => {
  const linkItems = document.querySelectorAll('.js-collection-stacked-item-link')
  const imageItems = document.querySelectorAll('.js-collection-stacked-image-item')

  const handleSelectedLink = (linkItem) => {
    const refIndex = linkItem.dataset.blockIndex
    const refImageClass = `.js-collection-stacked-image-item[data-featured-image-index="${refIndex}"]`

    imageItems.forEach((item) => {
      item.classList.remove('active')
    })

    const featuredImageEl = document.querySelector(refImageClass)
    featuredImageEl.classList.add('active')
  }

  linkItems.forEach((item) => {
    item.addEventListener('mouseover', () => handleSelectedLink(item))
    item.addEventListener('focusin', () => handleSelectedLink(item))
  })
})
